import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import Button from 'modules/_shared/components/Buttons';

import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';

const DividendsDistributionModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useDividendsDistributionModal();

  const hasValidDate = data.date && data.date >= data.lastOperationDate;

  const buttonEnabledScriptureView = data.scriptureView && hasValidDate;
  const buttonEnabledDataView = !data.scriptureView && data.totalAmount;

  const buttonText = data.scriptureView ? t('Next') : t('SaveOperation');

  return (
    <>
      <Modal.Footer>
        <Button
          onClick={actions.handleSaveDividends}
          disabled={!buttonEnabledScriptureView && !buttonEnabledDataView}
          lgSize
        >
          {buttonText}
        </Button>
      </Modal.Footer>
    </>
  );
};

export default DividendsDistributionModalFooter;
